import React, { Fragment } from "react";

import img13 from "../../../images/service/Hybrid Crypto Exchange Development/1.png";
import img14 from "../../../images/service/Hybrid Crypto Exchange Development/2.png";
import img15 from "../../../images/service/Hybrid Crypto Exchange Development/3.png";


import sIcon1 from "../../../images/icon/service-icon01.svg";
import sIcon2 from "../../../images/icon/service-icon02.svg";
import sIcon3 from "../../../images/icon/service-icon03.svg";
import sIcon4 from "../../../images/icon/service-icon04.svg";
import sIcon5 from "../../../images/icon/service-icon05.svg";
import sIcon6 from "../../../images/icon/service-icon06.svg";

import Header from "../../../components/Header/Header";
import PageTitle from "../../../components/pagetitle/PageTitle";
import Scrollbar from "../../../components/scrollbar/scrollbar";
import Footer from "../../../components/footer/Footer";

import HeroSection from "../../../components/PageSection/HeroSection";
import TheorySection from "../../../components/PageSection/Theory";
import ServiceCardsSection from "../../../components/PageSection/ServiceCardSection";
import Benefit from "../../../components/PageSection/BenefitSection";
import KeyFeaturesSection from "../../../components/PageSection/KeyFeature";
import WhyChooseUsSection from "../../../components/PageSection/WhyChooseUsSection";
import FaqSection from "../../../components/PageSection/FAQsection";
import FinalCenteredCTA from "../../../components/PageSection/FinalCTA";

// --------------------------------------------------
// DATA
// --------------------------------------------------

const serviceCards = [
  {
    icon: sIcon1,
    title: "Hybrid Exchange Architecture",
    content:
      "A powerful combination of centralized performance with decentralized security and transparency.",
  },
  {
    icon: sIcon2,
    title: "Liquidity Management",
    content:
      "Centralized liquidity with decentralized asset custody for optimal trading experience.",
  },
  {
    icon: sIcon3,
    title: "Smart Contract Integration",
    content:
      "Secure smart contracts for fund custody, settlements, and withdrawals.",
  },
];

const benefits = [
  {
    title: "Best of CEX & DEX",
    description:
      "Combines speed and liquidity of centralized exchanges with decentralization benefits.",
    icon: sIcon1,
  },
  {
    title: "Enhanced Security",
    description:
      "User funds remain protected through smart contracts and non-custodial mechanisms.",
    icon: sIcon2,
  },
  {
    title: "High Performance",
    description:
      "Centralized matching engine ensures fast order execution.",
    icon: sIcon3,
  },
  {
    title: "User Control",
    description:
      "Users maintain ownership of assets without third-party custody risks.",
    icon: sIcon4,
  },
  {
    title: "Regulatory Flexibility",
    description:
      "Supports compliance requirements while maintaining decentralization.",
    icon: sIcon5,
  },
  {
    title: "Scalable Design",
    description:
      "Built to handle increasing trading volume and user growth.",
    icon: sIcon6,
  },
];

const faqs = [
  {
    q: "What is a hybrid crypto exchange?",
    a: "A hybrid exchange combines centralized exchange speed with decentralized security and user fund control.",
  },
  {
    q: "How is it different from centralized exchanges?",
    a: "Hybrid exchanges reduce custodial risks while retaining high performance.",
  },
  {
    q: "Are hybrid exchanges secure?",
    a: "Yes. Funds are protected through smart contracts and decentralized custody models.",
  },
  {
    q: "Can hybrid exchanges scale?",
    a: "Yes. They are designed to scale efficiently with growing users and liquidity.",
  },
];

// --------------------------------------------------
// PAGE COMPONENT
// --------------------------------------------------

export default function HybridCryptoExchangeDevelopment() {
  return (
    <Fragment>
      <Header />

      <PageTitle
        pageTitle="Hybrid Crypto Exchange Development"
        pagesub="Combining centralized speed with decentralized security"
      />

      {/* ================= HERO ================= */}
      <HeroSection
        title={
          <>
            Build a Secure & Scalable{" "}
            <span className="gradient-text">Hybrid Crypto Exchange</span>
          </>
        }
        subtitle={`Hybrid crypto exchanges merge the best aspects of centralized
and decentralized platforms. We help you build secure, high-performance
hybrid exchanges with optimal liquidity and user control.`}
        buttonText="Build Hybrid Exchange"
        buttonLink="/contact"
        image={img13}
        imageAlt="Hybrid Crypto Exchange Development"
      />

      {/* ================= THEORY 1 ================= */}
      <TheorySection
        title="What Is Hybrid Crypto Exchange Development?"
        image={img14}
        paragraphs={[
          "Hybrid crypto exchange development focuses on building platforms that combine the performance and liquidity advantages of centralized exchanges with the transparency and security of decentralized systems. This approach addresses common challenges such as custodial risks and slow transaction speeds.",
          "By leveraging centralized matching engines alongside decentralized custody mechanisms, hybrid exchanges deliver fast trades while ensuring users retain control over their assets.",
        ]}
      />

      {/* ================= THEORY 2 ================= */}
      <TheorySection
        title="Why Hybrid Exchanges Are the Future"
        image={img15}
        paragraphs={[
          "As the crypto industry matures, users demand both speed and security. Hybrid exchanges meet this demand by offering instant trade execution without compromising decentralization principles.",
          "These platforms are ideal for businesses seeking regulatory flexibility, high liquidity, and enhanced trust—making them a preferred choice for modern crypto trading ecosystems.",
        ]}
      />

      {/* ================= SERVICES ================= */}
      <ServiceCardsSection
        title="Our Hybrid Exchange Development Services"
        cards={serviceCards}
      />

      {/* ================= BENEFITS ================= */}
      <Benefit
        title="Benefits of Hybrid Crypto Exchange Development"
        benefits={benefits}
      />

      {/* ================= KEY FEATURES ================= */}
      <KeyFeaturesSection
        title="Key Features of Hybrid Crypto Exchanges"
        subtitle="Designed for performance, security, and scalability."
        features={[
          {
            icon: sIcon1,
            title: "Centralized Matching Engine",
            description:
              "High-speed trade execution and order matching.",
          },
          {
            icon: sIcon2,
            title: "Decentralized Custody",
            description:
              "User-controlled assets secured via smart contracts.",
          },
          {
            icon: sIcon3,
            title: "Liquidity Aggregation",
            description:
              "Access liquidity from multiple sources.",
          },
          {
            icon: sIcon4,
            title: "Advanced Security",
            description:
              "Encryption, audits, and smart contract safeguards.",
          },
          {
            icon: sIcon5,
            title: "Compliance Ready",
            description:
              "Supports KYC, AML, and regulatory workflows.",
          },
          {
            icon: sIcon6,
            title: "Scalable Infrastructure",
            description:
              "Built to support high user traffic and volumes.",
          },
        ]}
      />

      {/* ================= WHY CHOOSE US ================= */}
      <WhyChooseUsSection
        items={[
          "Expert Hybrid Exchange Engineers",
          "Secure & Audited Architecture",
          "End-to-End Exchange Development",
        ]}
      />

      {/* ================= FAQ ================= */}
      <FaqSection faqs={faqs} />

      {/* ================= CTA ================= */}
      <FinalCenteredCTA />

      <Footer />
      <Scrollbar />
    </Fragment>
  );
}
